import React, {useMemo, useState} from 'react';
import useUserContext from "../../../../hooks/useUserContext";
import {isAdminRead} from "../../../../services/rolesSvc";
import UnifiedTable from "../../../Indexes/UnifiedTable";

const UnifiedTableTab = () => {
    const userCtx = useUserContext()
    const canExport = useMemo(()=>userCtx.perms.includes('kpiAdmin') || isAdminRead(userCtx),[])
    const [originalData, setOriginalData] = useState([]);

    return (
        <UnifiedTable
            data={{originalData,setOriginalData}}
            canExport={canExport}
            hasChildData={false}/>
    );
};

export default UnifiedTableTab;